import { resolveParentEntry, resolveBreadcrumbTrail } from './parentMap';

// Compose the four navigation anchors (back / parent / breadcrumbs / next) plus the
// role dashboard, enforcing the NEVER-TRAPPED guarantee: on every layout-bearing route
// at least one of { back, parent, next } is a navigable anchor (arch doc §4.1/§4.3).
export function resolveFlowModel({ pathname, history = [], auth, nextAction, parentMap, resolveDashboardPath }) {
  const dashboard = resolveDashboardPath(auth || {});

  // BACK: the most recent distinct prior in-app screen (structural parent may differ).
  let back = null;
  for (let i = history.length - 1; i >= 0; i--) {
    const h = history[i];
    if (h && h.path && h.path !== pathname) {
      back = { path: h.path, labelKey: 'experience.flowbar.back', label: h.label, source: 'history' };
      break;
    }
  }

  // PARENT: the structural container from the parent-map.
  const entry = resolveParentEntry(parentMap, pathname);
  let parent = null;
  if (entry && entry.parent) {
    const parentEntry = resolveParentEntry(parentMap, entry.parent);
    parent = {
      path: entry.parent,
      labelKey: (parentEntry && parentEntry.labelKey) || 'experience.flowbar.parent',
      source: 'parentMap',
    };
  }

  const breadcrumbs = resolveBreadcrumbTrail(parentMap, pathname);

  // NEXT: always present. The resolver guarantees a value; fall back to dashboard if absent.
  const next = nextAction || { path: dashboard.path, labelKey: 'experience.flowbar.dashboard', source: 'default' };

  // NEVER-TRAPPED: if neither Back nor Parent is available, Parent becomes the role dashboard.
  if (!back && !parent) {
    parent = { path: dashboard.path, labelKey: dashboard.labelKey, source: 'dashboard' };
  }

  return { back, parent, breadcrumbs, next, dashboard };
}
